import Stat from '../../stories/Stat/Stat'
import { DataPoint, useMetrics } from '../api'
import { useWidgetContext } from '../providers'
import { WidgetWrapper } from '../WidgetWrapper'
import { useFmt, isOrdinalStatistic } from '../format'
import { z } from 'zod'
import { useWidgetEditor } from '../state'
import { WidgetForm } from '../WidgetForm'
import { IconStar } from '@tabler/icons-react'
import { SimpleBoxOptions } from '../schemas'

type OptionsType = z.infer<typeof SimpleBoxOptions>

export default function SimpleBox(props: { id: string }) {
  const ctx = useWidgetContext()
  const editor = useWidgetEditor()
  const config = editor.useConfig(props.id)
  const metrics = useMetrics()

  if (config == null || config.widget !== 'SimpleBox') {
    console.error(
      `Invalid widget config for SimpleBox widget ${props.id}`,
      config
    )
    return null
  }

  const options: OptionsType = config.options
  const metric = metrics.data?.find((m) => m.key === options.metric)
  const title = options.title || metric?.name || options.metric || ''

  const component = options.component || ctx.component || 'actual'
  const statistic = options.statistic || ctx.statistic || 'value'

  const isOrdinal =
    options.format === 'ordinal' ||
    (options.format === 'default' && isOrdinalStatistic(statistic))

  // TODO if period/metric is not set, show error?
  const icon =
    metric?.key === 'rating' && component === 'actual' && statistic === 'value'
      ? IconStar
      : undefined

  return (
    <WidgetWrapper
      id={props.id}
      transformData={(data: DataPoint[]) => {
        const value = data && data.length === 1 ? data[0].value : null
        return { value }
      }}
      render={(data) => {
        const fmtValue = useFmt({
          metric: metric?.key || '',
          component,
          statistic,
          value: data.value,
        })

        return isOrdinal ? (
          <Stat
            title={title}
            value={data.value}
            isValueSub
            icon={icon}
            background="white"
          />
        ) : (
          <Stat title={title} value={fmtValue} icon={icon} background="white" />
        )
      }}
      query={() => ({
        period_type: ctx.period_type || 'total',
        period_range: false,
        periods: [ctx.period || '2025-01-01'],
        subject_type: ctx.subject_type || 'user',
        subject_ids: [ctx.subject || 0],
        metrics: [options.metric || ctx.metric || ''],
        components: [component],
        statistics: [statistic],
        competition_id: ctx.competition_id,
      })}
    />
  )
}

export const SimpleBoxRegistry = {
  component: SimpleBox,
  formComponent: WidgetForm,
  mock: () => <div>Mock SimpleBox</div>,
  getInitialOptions: () => SimpleBoxOptions.parse({}),
}
